import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  float: left;
  padding: 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: var(--white);

  @media (min-width: 64.5em) {
    height: 100vh;
  }
`;

export const Form = styled.form`
  width: 100%;

  @media (min-width: 64.5em) {
    max-width: 500px;
  }
`;

export const Title = styled.h1`
  margin-bottom: 20px;
  display: none;

  @media (min-width: 64.5em) {
    display: block;
  }
`;

export const Submit = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  margin-top: 40px;

  a {
    color: #666;
    font-weight: bold;

    &:hover {
      color: #000;
    }
  }
`;

export const Logotipo = styled.img`
  max-width: 120px;
  min-width: 80px;
`;

export const Center = styled.div`
  text-align: center;
`;

export const Division = styled.div`
  min-height: 100%;
  @media (min-width: 64.5em) {
    display: flex;
    height: 100vh;
  }
`;

export const Message = styled.div`
  display: none;
  background-color: rgba(162, 155, 254, .1);
  padding: 0 50px;

  @media (min-width: 64.5em) {
    flex: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;

    img {
      max-width: 200px;
      margin-bottom: 20px;
    }

    h1, p {
      margin: 10px 0;
    }
  }
`;
